// TODO Extract from SCSS. Should be possible, somehow... :^)
export const GRID_BREAKPOINTS = {
    xs: 0,
    sm: 360,
    smLarge: 580,
    md: 736,
    mdLarge: 1000,
    lg: 1312,
    xl: 1600
}